import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      fill: "currentColor",
      d: "M1.5 0h8S11 0 11 1.5v8S11 11 9.5 11h-8S0 11 0 9.5v-8S0 0 1.5 0m13 0h8S24 0 24 1.5v8s0 1.5-1.5 1.5h-8S13 11 13 9.5v-8S13 0 14.5 0m-13 13h8s1.5 0 1.5 1.5v8S11 24 9.5 24h-8S0 24 0 22.5v-8S0 13 1.5 13m13 0h8s1.5 0 1.5 1.5v8s0 1.5-1.5 1.5h-8S13 24 13 22.5v-8s0-1.5 1.5-1.5"
    }, null, -1)
  ]));
}
const programmingModuleFourLayout = { render };
export {
  programmingModuleFourLayout as default,
  render
};
//# sourceMappingURL=programming-module-four-layout.svg.js.map
